package uz.ferro.erp.feature.salesperson.model

import kotlinx.serialization.Serializable

@Serializable
data class SalesPersonDto(
    val id: Long,
    val name: String,
    val memo: String,
    val isActive: Boolean
)